// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__Wj+jF","createdSearch":"index_createdSearch__bLKQ+","custom_table":"index_custom_table__kRECg"};